export enum FactoryInvoiceTypeValue {
  SHIPMENT = 1,
  PERIODICAL = 2,
  BATCH_DEPOSIT = 3,
  BATCH_BALANCE = 4,
}

export const regularFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.SHIPMENT,
  FactoryInvoiceTypeValue.PERIODICAL,
];

export const batchFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.BATCH_DEPOSIT,
  FactoryInvoiceTypeValue.BATCH_BALANCE,
];
